import './Loading.css'

import React from 'react'

function Loading () {
  return <div className='loader'>Chargement...</div>
}
export default Loading
